import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  OnDestroy,
} from "@angular/core";
import { MatDialog as MatDialog } from "@angular/material/dialog";
import {
  HttpClient,
  HttpErrorResponse,
  HttpRequest,
} from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { TestDatasourceComponent } from "../test-datasource/test-datasource.component";
import {
  ApiMapperDetailsViewModel,
  ApiMapperOutputParam,
  ApiMapperViewModel,
  AuthorizationKeyResVM,
  AuthorizationKeyVM,
  DataSourceListDDL,
  DatasourceModel,
  ParentFieldMapping,
  TestDataSourceVM,
} from "src/app/models/module.model";
import { FormControl, FormGroup, NgForm } from "@angular/forms";
import {
  EAuthorizationType,
  ESourceType,
  ETokenSource,
} from "src/app/models/general-enums";
import { AuthService } from "src/app/services/auth.service";
import { map, tap } from "rxjs/operators";
import { DataSourceService } from "src/app/services/data-source.service";
import { AppError } from "src/app/error-handler/app-error";
import { ApiAuthenticationComponent } from "../api-authentication/api-authentication.component";
import { idLocale } from "ngx-bootstrap/chronos";
import { CookieService } from "ngx-cookie";
import { CdkDragDrop, transferArrayItem } from "@angular/cdk/drag-drop";

@Component({
  selector: "app-AddEdit-data-sorce",
  templateUrl: "./AddEdit-data-sorce.component.html",
  styleUrls: ["./AddEdit-data-sorce.component.css"],
})
export class AddEditDataSorceComponent implements OnInit, OnDestroy {
  service: any = {};
  input: any = {};
  key: any = {};
  queyStringInput: any = {};
  body: any = {};
  header: any = {};
  path: any = {};
  formFile: any = {};
  queryStringValues: any[] = [];
  bodyValues: any = ([] = []);
  headerValues: any = ([] = []);
  pathValues: any = ([] = []);
  formFileValues: any = ([] = []);
  unAssigendOutParams: any[] = [];
  assigendOutParams: any[] = [];
  outputKeys: any = {};
  after: any = {};
  @ViewChild("callTestDialog", { static: true })
  callTestDialog: TemplateRef<any>;
  mapperId: number;
  dataSourceObject: DatasourceModel = new DatasourceModel();
  tempInputParams = null;
  pathArray: string[] = [];
  clickButton = false;
  isLinear = false;
  authorizationTypes = EAuthorizationType;
  tokenSource = ETokenSource;
  ApiMapperParamsData = [];
  siteId: number;
  arrayBody: any = {};
  arrayBodyValues: any = ([] = []);
  dataSources: DataSourceListDDL[];
  apiResultObj: any;
  CookieName: any;
  CookieValue: any;
  authorizationType: any;
  thetokenSource: any;
  /** Blocks a second save while the first one is still in flight. */
  saving = false;
  duplicating = false;

  // Request log, filled the first time the Request Log step is opened.
  requestLog: any[] = [];
  requestLogLoading = false;
  requestLogFailed = false;
  requestLogLoaded = false;
  requestLogTotal = 0;
  requestLogPage = 0;
  requestLogPageSize = 10;
  expandedLogRow = -1;
  aliasform = new FormGroup({
    alias: new FormControl(),
  });

  // ---------------------------------------------------------------
  // Chaining: this data source runs after another one and reads
  // values out of its response.
  // ---------------------------------------------------------------

  /** Value source id a parameter carries when it reads a field of another API. */
  readonly parentSource = ESourceType.DependOnOtherApi;

  /**
   * The data source new mappings start from. Each parameter keeps its own
   * choice, so this is only the starting point the row picker is filled with.
   */
  defaultParentId: number = 0;

  /** Output fields per data source id, read once and kept for the page. */
  parentOutputsById: { [apiId: number]: ApiMapperOutputParam[] } = {};
  parentOutputsLoading: { [apiId: number]: boolean } = {};
  parentOutputsFailed: { [apiId: number]: boolean } = {};

  /** Every data source, so a chain can be checked for a loop back to itself. */
  private allDataSources: DataSourceListDDL[] = [];

  // Set from the picker just before a parameter row is built, so the row keeps
  // the data source and field it reads from.
  private pendingParentApiId: number = null;
  private pendingParentOutputParamId: number = null;
  private pendingParentField: string = null;

  constructor(
    private snotifyService: ToastrService,
    private dialog: MatDialog,
    private httpClient: HttpClient,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private cookieService: CookieService,

    private dataSourceService: DataSourceService,
  ) {}
  ngOnDestroy(): void {
    this.cookieService.remove(this.CookieName);
  }

  _authorizationTypes() {
    let keys = Object.keys(this.authorizationTypes);
    keys = keys.slice(keys.length / 2);
    const array = [];
    for (let k of keys) {
      array.push({ key: k, value: this.authorizationTypes[k] });
    }
    return array;
  }

  gettokenSource() {
    let keys = Object.keys(this.tokenSource);
    keys = keys.slice(keys.length / 2);
    const array = [];
    for (let k of keys) {
      if (this.tokenSource[k] != this.tokenSource.Cookie) {
        array.push({ key: k, value: this.tokenSource[k] });
      }
    }
    return array;
  }

  ngOnInit() {
    this.authorizationType = this._authorizationTypes();
    this.thetokenSource = this.gettokenSource();
    let user = this.authService.getLoggedUser();
    this.siteId = user.siteId;
    this.service.mediaTypes = "application/json";
    this.formFile.ValueSource = "8";
    this.activatedRoute.paramMap.subscribe((param) => {
      if (param.has("id")) {
        this.mapperId = +param.get("id");
        this.getDataSource(this.mapperId);
      } else {
        this.dataSourceObject = new DatasourceModel();
      }
    });
    this.getAllDataSources();
    this.loadScript();
  }

  getAllDataSources() {
    this.dataSourceService
      .getDatasourceList()
      .pipe(
        tap((data: DataSourceListDDL[]) => {
          this.allDataSources = data || [];
          this.dataSources = this.buildParentCandidates(this.allDataSources);
        }),
      )
      .subscribe();
  }

  /**
   * The data sources a parameter may read from. A data source cannot read from
   * itself, and it cannot read from one that already reads from it: that chain
   * would call itself forever.
   */
  private buildParentCandidates(all: DataSourceListDDL[]): DataSourceListDDL[] {
    if (!this.mapperId) {
      return all.slice();
    }
    return all.filter((item) => +item.id !== +this.mapperId);
  }

  /** Carries the picker choice into the parameter row about to be built. */
  private takePendingParentLink(source: any, model: any) {
    if (+source === ESourceType.DependOnOtherApi && model) {
      this.pendingParentApiId = +model.ParentApiId || null;
      this.pendingParentOutputParamId = +model.ParentOutputParamId || null;
      this.pendingParentField = model.Value || null;
    } else {
      this.pendingParentApiId = null;
      this.pendingParentOutputParamId = null;
      this.pendingParentField = null;
    }
  }

  /** Name of a data source, for labels and hints. */
  dataSourceName(apiId: number): string {
    const found = this.allDataSources.find((item) => +item.id === +apiId);
    return found ? found.name : "";
  }

  /** True once at least one parameter reads from another data source. */
  get isChained(): boolean {
    return this.parentFieldMappings.length > 0;
  }

  /** Reads the output fields of the data source new mappings start from. */
  onDefaultParentChange() {
    if (+this.defaultParentId) {
      this.loadParentOutputs(+this.defaultParentId);
    }
  }

  /** Output fields of one data source, loaded once and cached for the page. */
  loadParentOutputs(apiId: number) {
    if (!apiId || this.parentOutputsById[apiId] || this.parentOutputsLoading[apiId]) {
      return;
    }
    this.parentOutputsLoading[apiId] = true;
    this.parentOutputsFailed[apiId] = false;

    this.dataSourceService.getOutputParams(apiId).subscribe(
      (outputs: ApiMapperOutputParam[]) => {
        this.parentOutputsLoading[apiId] = false;
        this.parentOutputsById[apiId] = outputs || [];
      },
      () => {
        this.parentOutputsLoading[apiId] = false;
        this.parentOutputsFailed[apiId] = true;
        this.parentOutputsById[apiId] = [];
      },
    );
  }

  /** Output fields already loaded for a data source. */
  outputsOf(apiId: number): ApiMapperOutputParam[] {
    return this.parentOutputsById[+apiId] || [];
  }

  /**
   * Starts a new "from another data source" row on the usual data source, so the
   * common case of every parameter reading the same one is a single choice.
   */
  onValueSourceChange(model: any) {
    if (!model) {
      return;
    }
    if (+model.ValueSource !== ESourceType.DependOnOtherApi) {
      return;
    }
    if (!+model.ParentApiId && +this.defaultParentId) {
      model.ParentApiId = +this.defaultParentId;
      this.loadParentOutputs(+this.defaultParentId);
    }
  }

  /** Fills the field picker of a row after its data source is chosen. */
  onRowParentChange(model: any) {
    if (!model) {
      return;
    }
    model.Value = "";
    model.ParentOutputParamId = null;
    if (+model.ParentApiId) {
      this.loadParentOutputs(+model.ParentApiId);
    }
  }

  /** Keeps the chosen field and its id together, the id is what gets saved. */
  onRowFieldChange(model: any) {
    if (!model) {
      return;
    }
    const field = this.outputsOf(+model.ParentApiId).find(
      (item) => item.paramName === model.Value,
    );
    model.ParentOutputParamId = field ? field.id : null;
  }

  /** True when the data source no longer returns a field a parameter reads. */
  isParentFieldMissing(apiId: number, fieldName: string): boolean {
    if (!fieldName || !apiId) {
      return false;
    }
    if (this.parentOutputsLoading[apiId] || this.parentOutputsFailed[apiId]) {
      return false;
    }
    if (!this.parentOutputsById[apiId]) {
      return false;
    }
    return !this.parentOutputsById[apiId].some(
      (item) => item.paramName === fieldName,
    );
  }

  /**
   * Every parameter that reads a field of another data source, in the order the
   * request is built: header, body, query string, path.
   */
  get parentFieldMappings(): ParentFieldMapping[] {
    const sections: { area: string; rows: any[] }[] = [
      { area: "Header", rows: this.headerValues },
      { area: "Body", rows: this.bodyValues },
      { area: "Query string", rows: this.queryStringValues },
      { area: "Path", rows: this.pathValues },
      { area: "Array body", rows: this.arrayBodyValues },
    ];
    const mappings: ParentFieldMapping[] = [];

    sections.forEach((section) => {
      (section.rows || []).forEach((row: any) => {
        if (+row.sourceType !== ESourceType.DependOnOtherApi) {
          return;
        }
        const parentField = row.parentField || row.paramValue || row.paramName;
        const parentApiId = +row.parentApiId || 0;
        mappings.push({
          paramName: row.paramName,
          parentField: parentField,
          parentApiId: parentApiId,
          parentApiName: this.dataSourceName(parentApiId),
          parentOutputParamId: row.parentOutputParamId || null,
          area: section.area,
          resolved:
            !!parentApiId &&
            !!row.parentOutputParamId &&
            !this.isParentFieldMissing(parentApiId, parentField),
        } as ParentFieldMapping);
      });
    });

    return mappings;
  }

  /** How many mapped parameters can no longer be resolved. */
  get brokenMappingCount(): number {
    return this.parentFieldMappings.filter((item) => !item.resolved).length;
  }

  /**
   * Stops a parameter from being added when it reads another data source but no
   * data source or no field was chosen.
   */
  private parentSourceReady(source: any, model: any): boolean {
    if (+source !== ESourceType.DependOnOtherApi) {
      return true;
    }
    if (!model || !+model.ParentApiId) {
      this.snotifyService.warning(
        "Choose the data source this parameter reads from.",
        "",
        { timeOut: 4000, progressBar: true, tapToDismiss: true },
      );
      return false;
    }
    if (!model.Value || !model.ParentOutputParamId) {
      this.snotifyService.warning(
        "Choose which field of " +
          (this.dataSourceName(+model.ParentApiId) || "that data source") +
          " fills this parameter.",
        "",
        { timeOut: 4000, progressBar: true, tapToDismiss: true },
      );
      return false;
    }
    return true;
  }

  /**
   * The links the server stores for this data source: one row per parameter,
   * naming the data source to run first and the output field to read.
   * Sent with the save, so no separate linking call is needed.
   */
  private buildChildren(): any[] {
    return this.parentFieldMappings
      .filter((item) => item.parentApiId && item.parentOutputParamId)
      .map((item, index) => ({
        ParamName: item.paramName,
        ApiMapperParamChildId: item.parentOutputParamId,
        parentId: item.parentApiId,
        executionOrder: index,
      }));
  }

  /**
   * Reads the stored links back after a load. The server returns them on the
   * data source and, depending on how the navigation resolves, on each input,
   * so both places are merged and matched on the parameter name.
   */
  private applySavedLinks(res: any) {
    const links: any[] = [];
    const collect = (rows: any) => {
      (rows || []).forEach((row: any) => {
        if (row && row.paramName) {
          links.push(row);
        }
      });
    };

    collect(res ? res.apiMapperParamChild : null);
    (res && res.inputs ? res.inputs : []).forEach((input: any) =>
      collect(input.apiMapperParamChild),
    );

    const byName: { [paramName: string]: any } = {};
    links.forEach((link) => {
      if (!byName[link.paramName]) {
        byName[link.paramName] = link;
      }
    });

    const sections = [
      this.headerValues,
      this.bodyValues,
      this.queryStringValues,
      this.pathValues,
      this.arrayBodyValues,
    ];

    const parentIds: number[] = [];

    sections.forEach((rows) => {
      (rows || []).forEach((row: any) => {
        const link = byName[row.paramName];
        if (!link || +row.sourceType !== ESourceType.DependOnOtherApi) {
          return;
        }
        row.parentApiId = +link.parentId || 0;
        row.parentOutputParamId = +link.apiMapperParamChildId || null;
        if (row.parentApiId && parentIds.indexOf(row.parentApiId) === -1) {
          parentIds.push(row.parentApiId);
        }
      });
    });

    if (parentIds.length) {
      this.defaultParentId = parentIds[0];
    }

    // The link stores the field by id, so the name comes from the outputs of
    // each data source involved.
    parentIds.forEach((apiId) => {
      this.dataSourceService.getOutputParams(apiId).subscribe(
        (outputs: ApiMapperOutputParam[]) => {
          this.parentOutputsById[apiId] = outputs || [];
          this.namePendingFields(apiId);
        },
        () => {
          this.parentOutputsFailed[apiId] = true;
          this.parentOutputsById[apiId] = [];
        },
      );
    });
  }

  /** Turns the stored output param ids into the field names shown on screen. */
  private namePendingFields(apiId: number) {
    const outputs = this.parentOutputsById[apiId] || [];
    const sections = [
      this.headerValues,
      this.bodyValues,
      this.queryStringValues,
      this.pathValues,
      this.arrayBodyValues,
    ];

    sections.forEach((rows) => {
      (rows || []).forEach((row: any) => {
        if (+row.parentApiId !== +apiId || !row.parentOutputParamId) {
          return;
        }
        const field = outputs.find(
          (item) => +item.id === +row.parentOutputParamId,
        );
        if (field) {
          row.parentField = field.paramName;
          row.paramValue = field.paramName;
        }
      });
    });
  }

  loadScript() {
    const head = document.getElementsByTagName("head")[0];
    const script = document.createElement("link");
    script.href = "./assets/plugins/custom/kanban/kanban.bundle.css";
    script.rel = "stylesheet";
    script.type = "text/css";
    var oldJs = document.getElementsByTagName("link");
    for (let index = 0; index < oldJs.length; index++) {
      const element = oldJs[index];
      if (element.href.indexOf("kanban.bundle.css") != -1) {
        head.removeChild(element);
        index = index - 1;
      }
    }
    head.appendChild(script);
  }

  getDataSource(id) {
    this.dataSourceService
      .getDatasource(id)
      .pipe(
        map((res: ApiMapperDetailsViewModel) => {
          this.service = res;

          this.service.authorizationType = res.authorizationType;
          switch (+this.service.authorizationType) {
            case EAuthorizationType.Basic:
              this.service.Username = res.authorizationKeys.find(
                (x) => x.key === "username",
              )
                ? res.authorizationKeys.find((x) => x.key === "username").value
                : undefined;
              this.service.Password = res.authorizationKeys.find(
                (x) => x.key === "password",
              )
                ? res.authorizationKeys.find((x) => x.key === "password").value
                : undefined;
              break;
            case EAuthorizationType.JWT:
              if (res.authorizationKeys && res.authorizationKeys[0])
                this.service.tokenSource = res.authorizationKeys[0].tokenSource;
              let refreshToken;
              let token;
              let InputCookieName: any;
              switch (+this.service.tokenSource) {
                case ETokenSource.DataBase:
                  token = res.authorizationKeys.find(
                    (x) => x.key === "DatabaseToken",
                  );
                  refreshToken = res.authorizationKeys.find(
                    (x) => x.key === "DatabaseRefreshToken",
                  );

                  this.service.DatabaseToken = token ? token.value : undefined;
                  this.service.refreshToken = refreshToken
                    ? refreshToken.value
                    : undefined;
                  break;
                case ETokenSource.LocalStorage:
                  refreshToken = res.authorizationKeys.find(
                    (x) => x.key === "LocalStorageRefreshToken",
                  );
                  token = res.authorizationKeys.find(
                    (x) => x.key === "LocalStorageToken",
                  );

                  this.service.LocalStorageToken = token
                    ? token.value
                    : undefined;
                  this.service.LocalStorageRefreshToken = refreshToken
                    ? refreshToken.value
                    : undefined;
                  break;
              }
              break;
            case EAuthorizationType.Cookies:
              this.service.InputCookieName = res.authorizationKeys.find(
                (x) => x.key === "InputCookieName",
              )
                ? res.authorizationKeys.find((x) => x.key === "InputCookieName")
                    .value
                : undefined;
              this.CookieName = this.service.InputCookieName;
              break;
          }
          this.dataSourceObject.inputs = this.service.inputs;
          this.dataSourceObject.outputs = this.service.outputs;

          this.service.inputs.forEach((element) => {
            if (element.paramType == 1) {
              this.headerValues.push(element);
            } else if (element.paramType == 2) {
              this.bodyValues.push(element);
            } else if (element.paramType == 3) {
              this.queryStringValues.push(element);
            } else if (element.paramType == 4) {
              this.pathValues.push(element);
            } else if (element.paramType == 5) {
              this.arrayBodyValues.push(element);
            } else if (element.paramType == 6) {
              this.formFileValues.push(element);
            }
          });

          this.assigendOutParams = (this.service.outputs || []).map(
            (field: any) => this.asOutputField(field),
          );
          this.syncInputSections();
          this.applySavedLinks(res);

          if (res.path) {
            this.outputKeys.test = res.path;
            this.pathArray = res.path.split("=>");
            this.dataSourceObject.paths = this.pathArray;
          }
        }),
      )
      .subscribe();
  }

  /** Builds the mapper payload. Returns false when the setup step is incomplete. */
  check(form) {
    if (form.invalid) {
      Object.keys(form.controls).forEach((feild) => {
        form.controls[feild].markAsTouched(true);
      });
      return false;
    }
    let data: ApiMapperViewModel = {
      Id: this.mapperId ? this.mapperId : 0,
      Name: this.service.name,
      Description: this.service.description,
      URL: this.service.url,
      HttpMethod: this.service.httpMethod,
      MediaTypes: this.service.mediaTypes,
      Type: this.service.type,
      Status: 5,
      ApiMapperParams: [],
      IsSecured: true,
      ApiReponseType: this.service.apiReponseType,
      SiteId: this.siteId,
      ContractName: "",
      ContentType: "",
      Accept: "",
      WebMethodName: "",
      AuthorizationKeys: [],
      AuthorizationType: this.service.authorizationType,
      // The parent moved to the per parameter links sent in "children".
      ParentId: null,
      EnableLog: !!this.service.enableLog,
    };
    data.AuthorizationKeys = [];
    switch (+this.service.authorizationType) {
      case EAuthorizationType.Basic:
        data.AuthorizationKeys.push(
          {
            Key: "username",
            Value: this.service.Username,
            TokenSource: this.service.tokenSource,
          },
          {
            Key: "password",
            Value: this.service.Password,
            TokenSource: this.service.tokenSource,
          },
        );
        break;
      case EAuthorizationType.JWT:
        switch (+this.service.tokenSource) {
          case ETokenSource.DataBase:
            data.AuthorizationKeys.push({
              Key: "DatabaseToken",
              Value: this.service.DatabaseToken,
              TokenSource: this.service.tokenSource,
            });
            data.AuthorizationKeys.push({
              Key: "DatabaseRefreshToken",
              Value: this.service.DatabaseRefreshToken,
              TokenSource: this.service.tokenSource,
            });
            break;
          case ETokenSource.LocalStorage:
            data.AuthorizationKeys.push({
              Key: "LocalStorageToken",
              Value: this.service.LocalStorageToken,
              TokenSource: this.service.tokenSource,
            });
            data.AuthorizationKeys.push({
              Key: "LocalStorageRefreshToken",
              Value: this.service.LocalStorageRefreshToken,
              TokenSource: this.service.tokenSource,
            });
            break;
        }
        break;
      case EAuthorizationType.Cookies:
        this.service.tokenSource = ETokenSource.Cookie;
        this.CookieName = this.service.InputCookieName;
        data.AuthorizationKeys.push({
          Key: "InputCookieName",
          Value: this.service.InputCookieName,
          TokenSource: this.service.tokenSource,
        });
        break;
    }
    this.dataSourceObject.apiMapperViewModel = data;
    return true;
  }

  saveInputHandler(arrayItem) {
    arrayItem.forEach((element) => {
      this.dataSourceObject.inputs.push(element);
    });
  }

  get pageTitle(): string {
    return this.mapperId ? "Edit data source" : "New data source";
  }

  get pageSubtitle(): string {
    if (!this.mapperId) {
      return "New Data Source";
    }
    return this.service && this.service.name ? this.service.name : "Edit Data Source";
  }

  /** Copies this data source server side and opens the copy. */
  duplicate() {
    if (!this.mapperId || this.duplicating) {
      return;
    }
    this.duplicating = true;

    this.dataSourceService.duplicateDataSource(this.mapperId).subscribe(
      (result) => {
        this.duplicating = false;
        this.snotifyService.success(`Created ${result.name}`, "", {
          timeOut: 3000,
          progressBar: true,
          tapToDismiss: true,
        });
        this.router
          .navigateByUrl("/data-source", { skipLocationChange: true })
          .then(() => this.router.navigate(["/data-source/edit", result.id]));
      },
      (error) => {
        this.duplicating = false;
        this.snotifyService.error(
          typeof error.error === "string" && error.error
            ? error.error
            : "The copy could not be created. Try again.",
          "",
          { timeOut: 3000, progressBar: true, tapToDismiss: true },
        );
      },
    );
  }

  save(form: any) {
    if (this.saving) {
      return;
    }
    this.cookieService.remove(this.CookieName, this.CookieValue);
    this.CookieValue = undefined;
    if (!this.check(form)) {
      // Data Setup is reachable out of order, so guard the save rather than the step.
      this.snotifyService.warning(
        'Complete the required fields in Data Setup before saving.',
        '',
        { timeOut: 3000, progressBar: true, tapToDismiss: true },
      );
      return;
    }
    let serviceCopy = { ...this.service };
    delete serviceCopy.inputs;
    delete serviceCopy.outputs;
    this.dataSourceObject.outputs = this.buildOutputsPayload();
    this.dataSourceObject.inputs = [];
    this.dataSourceObject.inputs = [];
    this.dataSourceObject.tokenSource = this.service.tokenSource;

    this.saveInputHandler(this.headerValues);
    if (this.input.BodyType == "1") {
      this.saveInputHandler(this.bodyValues);
    } else if (this.input.BodyType == "2") {
      this.saveInputHandler(this.arrayBodyValues);
    }
    this.saveInputHandler(this.queryStringValues);
    this.saveInputHandler(this.pathValues);
    this.saveInputHandler(this.formFileValues);
    this.dataSourceObject.BodyType = this.input.BodyType;
    this.dataSourceObject.children = this.buildChildren();

    if (this.outputKeys.test) {
      this.pathArray = this.outputKeys.test.split("=>");
      this.dataSourceObject.paths = this.pathArray;
    }
    if (!this.mapperId) {
      this.addDataSource();
    } else {
      this.editDataSource();
    }
  }

  addDataSource() {
    this.saving = true;
    this.httpClient.post(`/ApiInvoker/AddDataSource`, this.dataSourceObject).subscribe(
      (res) => {
        this.saving = false;
        this.snotifyService.success(`Data source added successfully`, "", {
          timeOut: 2000,
          progressBar: true,
          tapToDismiss: true,
        });
        this.router.navigateByUrl("/data-source");
        this.pathArray = [];
      },
      () => {
        this.saving = false;
        this.snotifyService.error("The data source could not be saved. Try again.", "", {
          timeOut: 3000,
          progressBar: true,
          tapToDismiss: true,
        });
      },
    );
  }

  editDataSource() {
    this.saving = true;
    this.httpClient.post(`/ApiInvoker/EditDataSource`, this.dataSourceObject).subscribe(
      (res) => {
        this.saving = false;
        this.snotifyService.success(`Data source edited successfully`, "", {
          timeOut: 2000,
          progressBar: true,
          tapToDismiss: true,
        });
        this.router.navigateByUrl("/data-source");
        this.pathArray = [];
      },
      () => {
        this.saving = false;
        this.snotifyService.error("The changes could not be saved. Try again.", "", {
          timeOut: 3000,
          progressBar: true,
          tapToDismiss: true,
        });
      },
    );
  }
  getType(type) {
    if (type === null) {
      return;
    }
    switch (+type) {
      case 1:
        return "Static";

      case 2:
        return "Router Parameter";

      case 3:
        return "Local Storage";

      case 4:
        return "Session Storage";
      case 5:
        return "User";
      case 6:
        return "Result Data";
      case 7:
        return "Control";
      case 8:
        return "File";
      case 9:
        return "Control Or Default";
      case 10:
        return "Token Claims";
      case 11:
        return "From another data source";
    }
  }

  /** What a saved parameter reads, for the tooltip on its chip. */
  describeSource(chip: any): string {
    if (+chip.sourceType === ESourceType.DependOnOtherApi) {
      const field = chip.parentField || chip.paramValue || chip.paramName;
      const api = this.dataSourceName(+chip.parentApiId) || "Another data source";
      return api + " \u2192 " + field;
    }
    return this.getType(chip.sourceType);
  }
  structInputData(
    name,
    direction,
    paramType,
    index,
    arrayData,
    source,
    value,
    defaultValue,
  ) {
    let data;
    if (this.tempInputParams) {
      data = {
        id: this.tempInputParams.id,
        apiMapperId: this.tempInputParams.apiMapperId,
        paramName: name,
        paramOrder: this.tempInputParams.paramOrder,
        direction: this.tempInputParams.direction
          ? this.tempInputParams.direction
          : direction,
        paramType: this.tempInputParams.paramType,
        sourceType: source,
        paramValue: value,
        defaultValue: defaultValue,
        parentApiId: this.tempInputParams.parentApiId,
        parentOutputParamId: this.tempInputParams.parentOutputParamId,
        parentField: this.tempInputParams.parentField,
      };
    } else {
      data = {
        id: 0,
        apiMapperId: this.mapperId,
        paramName: name,
        paramOrder: 0,
        direction: direction,
        paramType: paramType,
        sourceType: source,
        paramValue: value,
        defaultValue: defaultValue,
      };
    }
    if (this.tempInputParams != null) {
      arrayData.splice(
        arrayData.findIndex(
          (f) =>
            f.id === this.tempInputParams.id &&
            f.direction === this.tempInputParams.direction &&
            f.paramType === this.tempInputParams.paramType &&
            f.sourceType === this.tempInputParams.sourceType,
        ),
        1,
      );
    }
    arrayData.push(data);
    return arrayData;
  }

  structChipData(
    name,
    index,
    source,
    value,
    direction,
    paramType,
    defaultValue,
  ) {
    let data = {
      id: this.tempInputParams ? this.tempInputParams.id : 0,
      apiMapperId: this.mapperId,
      paramName: name,
      paramOrder: this.tempInputParams ? this.tempInputParams.paramOrder : 0,
      direction: this.tempInputParams
        ? this.tempInputParams.direction
        : direction,
      paramType: this.tempInputParams
        ? this.tempInputParams.paramType
        : paramType,
      sourceType: source,
      paramValue: value,
      defaultValue: defaultValue,
      parentApiId: this.pendingParentApiId,
      parentOutputParamId: this.pendingParentOutputParamId,
      parentField: this.pendingParentField,
    };

    this.apiMapperParamsStruct(data);
    this.tempInputParams = null;

    return data;
  }

  addParamsQueryString(name, source, value, form: NgForm, index, defaultValue, model?) {
    if (!this.parentSourceReady(source, model)) {
      return;
    }
    this.takePendingParentLink(source, model);
    if (name) {
      this.dataSourceObject.inputs = this.structInputData(
        name,
        1,
        3,
        index,
        this.dataSourceObject.inputs,
        source,
        value,
        defaultValue,
      );
      this.queryStringValues.push(
        this.structChipData(name, index, source, value, 1, 3, defaultValue),
      );
      this.queyStringInput = {};
      form.reset();
    }
  }

  addParamsBody(name, source, value, form: NgForm, index, defaultValue, model?) {
    if (!this.parentSourceReady(source, model)) {
      return;
    }
    this.takePendingParentLink(source, model);
    if (name) {
      this.dataSourceObject.inputs = this.structInputData(
        name,
        1,
        2,
        index,
        this.dataSourceObject.inputs,
        source,
        value,
        defaultValue,
      );

      this.bodyValues.push(
        this.structChipData(name, index, source, value, 1, 2, defaultValue),
      );
      this.body = {};
      form.reset();
    }
  }
  addParamsarrayBody(name, source, value, form: NgForm, index, defaultValue, model?) {
    if (!this.parentSourceReady(source, model)) {
      return;
    }
    this.takePendingParentLink(source, model);
    if (name) {
      this.dataSourceObject.inputs = this.structInputData(
        name,
        1,
        5,
        index,
        this.dataSourceObject.inputs,
        source,
        value,
        defaultValue,
      );

      this.arrayBodyValues.push(
        this.structChipData(name, index, source, value, 1, 5, defaultValue),
      );
      this.arrayBody = {};

      form.reset();
    }
  }

  addParamsheader(name, source, value, form: NgForm, index, defaultValue, model?) {
    if (!this.parentSourceReady(source, model)) {
      return;
    }
    this.takePendingParentLink(source, model);
    if (name) {
      this.dataSourceObject.inputs = this.structInputData(
        name,
        1,
        1,
        index,
        this.dataSourceObject.inputs,
        source,
        value,
        defaultValue,
      );

      this.headerValues.push(
        this.structChipData(name, index, source, value, 1, 1, defaultValue),
      );
      this.header = {};
      form.reset();
    }
  }

  addParamsPath(name, source, value, form: NgForm, index, defaultValue, model?) {
    if (!this.parentSourceReady(source, model)) {
      return;
    }
    this.takePendingParentLink(source, model);
    if (name) {
      this.dataSourceObject.inputs = this.structInputData(
        name,
        1,
        4,
        index,
        this.dataSourceObject.inputs,
        source,
        value,
        defaultValue,
      );
      this.pathValues.push(
        this.structChipData(name, index, source, value, 1, 4, defaultValue),
      );
      this.path = {};
      form.reset();
    }
  }

  addParamsFormFile(name, value, form: NgForm, index) {
    const source = 8;
    if (name) {
      this.dataSourceObject.inputs = this.structInputData(
        name,
        1,
        6,
        index,
        this.dataSourceObject.inputs,
        source,
        value,
        undefined,
      );
      this.formFileValues.push(
        this.structChipData(name, index, source, value, 1, 6, undefined),
      );
      this.formFile = { ValueSource: "8" };
      form.reset();
    }
  }

  checkInputField(array, stepper) {
    if (array.length == 0) {
      this.snotifyService.warning("", "Please Add a Name  For the site", {
        timeOut: 2000,
        progressBar: true,
        tapToDismiss: true,
      });
    } else {
      stepper.next();
    }
  }

  checkKeys(test) {
    if (this.outputKeys.test) {
      this.outputKeys.test = this.outputKeys.test
        .replace(" ", "=>")
        .replace(",", "=>")
        .replace(".", "=>")
        .replace("/", "=>")
        .replace("\\", "=>");
    }
    console.log("this.outputKeys.test", this.outputKeys.test);
  }

  apiMapperParamsStruct(paramData) {
    let data = {
      apiMapperId: paramData.apiMapperId,
      paramName: paramData.paramName,
      paramOrder: paramData.paramOrder,
      parentId: 0,
      direction: paramData.direction,
      paramType: paramData.paramType,
      sourceType: paramData.sourceType,
      paramValue: paramData.paramValue,
    };

    if (this.tempInputParams != null) {
      this.service.apiMapperParams.splice(
        this.service.apiMapperParams.findIndex(
          (f) =>
            f.id === this.tempInputParams.id &&
            f.direction === this.tempInputParams.direction &&
            f.paramType === this.tempInputParams.paramType &&
            f.sourceType === this.tempInputParams.sourceType,
        ),
        1,
      );
    }

    if (!this.service.apiMapperParams) {
      this.service.apiMapperParams = [];
      this.service.apiMapperParams.push(data);
    } else {
      this.service.apiMapperParams.push(data);
    }
    // this.ApiMapperParamsData.push(data);
  }

  testKeys(token?: string) {
    this.callTestAPI(token);
    console.log("------------------------------------", this.assigendOutParams);
    console.log("++++++++++++++++++++++", this.unAssigendOutParams);
  }

  saveCooKie() {
    this.cookieService.put(this.CookieName, this.CookieValue);
    this.testKeys();
  }

  checkParentAPI() {
    if (this.defaultParentId) {
      this.dataSourceService
        .getDatasource(this.defaultParentId)
        .pipe(
          map((res: ApiMapperDetailsViewModel) => {
            const headerValues = [];
            const bodyValues = [];
            const queryStringValues = [];
            const pathValues = [];
            const bodyArrayValues = [];
            if (res) {
              res.inputs.forEach((element) => {
                if (element.paramType == 1) {
                  headerValues.push(element);
                } else if (element.paramType == 2) {
                  bodyValues.push(element);
                } else if (element.paramType == 3) {
                  queryStringValues.push(element);
                } else if (element.paramType == 4) {
                  pathValues.push(element);
                } else if (element.paramType == 5) {
                  bodyArrayValues.push(element);
                }
              });

              let api: TestDataSourceVM = {
                id: res.id,
                bodyParams: bodyValues,
                headerParams: headerValues,
                queryParams: queryStringValues,
                arrayBodyParams: bodyValues,
                firstStepData: {
                  Id: res.id,
                  Name: res.name,
                  Description: res.description,
                  URL: res.url,
                  HttpMethod: +res.httpMethod,
                  MediaTypes: res.mediaTypes,
                  ApiMapperParams: res.apiMapperParams,
                  Type: +res.type,
                  Status: 5,
                  IsSecured: true,
                  ApiReponseType: res.apiReponseType,
                  Obj: {},
                  AuthorizationType: res.authorizationType,
                  AuthorizationKeys: [],
                },
              };

              api.firstStepData.AuthorizationKeys = res.authorizationKeys.map(
                (key: AuthorizationKeyResVM) => {
                  return {
                    Key: key.key,
                    Value: key.value,
                    TokenSource: key.tokenSource,
                  };
                },
              );

              this.callTestAPI(undefined, api, true);
            }
          }),
          // map((res) => {
          //   if (res && res.authorizationType) {

          //   }

          // }
          // )
        )
        .subscribe();
    }
  }

  callTestAPI(
    token?: string,
    api?: TestDataSourceVM,
    isParentCall: Boolean = false,
  ) {
    if (!api) {
      api = {
        id: this.mapperId,
        bodyParams: this.bodyValues,
        headerParams: this.headerValues,
        queryParams: this.queryStringValues,
        arrayBodyParams: this.arrayBodyValues,

        path: this.outputKeys.test,
        unAssigendOutParams: this.unAssigendOutParams,
        assigendOutParams: this.assigendOutParams,
        dataSourceHeader: token,
        bodyType: this.input.BodyType,
        firstStepData: {
          Id: this.mapperId ? this.mapperId : 0,
          Name: this.service.name,
          Description: this.service.description,
          URL: this.service.url,
          HttpMethod: +this.service.httpMethod,
          MediaTypes: this.service.mediaTypes,
          ApiMapperParams: this.service.apiMapperParams,
          Type: +this.service.type,
          Status: 5,
          IsSecured: true,
          ApiReponseType: this.service.apiReponseType,
          AuthorizationKeys: [],
          AuthorizationType: this.service.authorizationType,
          Obj: {},
        },
      };

      api.firstStepData.AuthorizationKeys = [];
      switch (+this.service.authorizationType) {
        case EAuthorizationType.Basic:
          api.firstStepData.AuthorizationKeys.push(
            {
              Key: "username",
              Value: this.service.Username,
              TokenSource: this.service.tokenSource,
            },
            {
              Key: "password",
              Value: this.service.Password,
              TokenSource: this.service.tokenSource,
            },
          );
          break;
        case EAuthorizationType.JWT:
          switch (+this.service.tokenSource) {
            case ETokenSource.DataBase:
              api.firstStepData.AuthorizationKeys.push({
                Key: "DatabaseToken",
                Value: this.service.DatabaseToken,
                TokenSource: this.service.tokenSource,
              });
              api.firstStepData.AuthorizationKeys.push({
                Key: "DatabaseRefreshToken",
                Value: this.service.DatabaseRefreshToken,
                TokenSource: this.service.tokenSource,
              });
              break;
            case ETokenSource.LocalStorage:
              api.firstStepData.AuthorizationKeys.push({
                Key: "LocalStorageToken",
                Value: this.service.LocalStorageToken,
                TokenSource: this.service.tokenSource,
              });
              api.firstStepData.AuthorizationKeys.push({
                Key: "LocalStorageRefreshToken",
                Value: this.service.LocalStorageRefreshToken,
                TokenSource: this.service.tokenSource,
              });
              break;
          }
          break;
        case EAuthorizationType.Cookies:
          this.service.tokenSource = ETokenSource.Cookie;
          this.CookieName = this.service.InputCookieName;
          api.firstStepData.AuthorizationKeys.push({
            Key: "InputCookieName",
            Value: this.service.InputCookieName,
            TokenSource: this.service.tokenSource,
          });
      }
    }
    let dialogRef = this.dialog.open(TestDatasourceComponent, {
      width: "70vw",
      data: api,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.cookieService.remove(this.CookieName);
      this.CookieValue = undefined;
      if (result instanceof AppError || result instanceof HttpErrorResponse) {
        if (
          (result.status == 401 ||
            result.message.includes("(401) Unauthorized")) &&
          +this.service.authorizationType === EAuthorizationType.JWT &&
          this.defaultParentId
        ) {
          let confirmDialogRef = this.dialog.open(ApiAuthenticationComponent, {
            width: "70vw",
            data: {
              modalName: "Confirmation",
              message:
                "This Api call needs to be authenticated by calling the parent API. Are you sure you want to proceed?",
            },
          });
          confirmDialogRef.afterClosed().subscribe((res) => {
            if (res && res.result == "confirmed") {
              this.checkParentAPI();
              // else if(this.service.authorizationType === EAuthorizationType.Basic){
              //   let authDialogRef = this.dialog.open(ApiAuthenticationComponent, {
              //     width: "70vw"});

              //     authDialogRef.afterClosed().subscribe(authResult => {
              //       if (result instanceof AppError || result instanceof HttpErrorResponse) {
              //         this.openAlert(result.message);
              //       }else{

              //       }
              //     })
              // }
              // else if (this.service.authorizationType === EAuthorizationType.None)
              // {
              //   this.openAlert(result.message);
              // }
            }
          });
        } else {
          this.snotifyService.error("", result.message, {
            timeOut: 2000,
            progressBar: true,
            tapToDismiss: true,
          });
        }
      } else if (result && isParentCall) {
        if (result) {
          this.apiResultObj = result.fullResponse;
          if (this.apiResultObj) {
            let dialogRef = this.dialog.open(ApiAuthenticationComponent, {
              width: "70vw",
              data: {
                modalName: "Preview",
                message: "Please copy the token to insert it in the next step.",
                obj: this.apiResultObj,
              },
            });

            dialogRef.afterClosed().subscribe((res) => {
              let jwtDialogeRef = this.dialog.open(ApiAuthenticationComponent, {
                width: "70vw",
                data: {
                  modalName: "JWT",
                  message: "Please enter the received token",
                },
              });
              jwtDialogeRef.afterClosed().subscribe((res) => {
                if (res && res.token) {
                  console.log(res);

                  this.testKeys(res.token);
                }
              });
            });
          }
        }
      } else if (result && !isParentCall) {
        if (result) {
          console.log(result, "ressssssssssss");
          this.unAssigendOutParams = [];
          //this.ApiMapperParamsData = [];
          this.unAssigendOutParams =
            result.unAssigendOutParams.length > 0
              ? result.unAssigendOutParams
              : [];
        } else {
          this.unAssigendOutParams = [];
        }
      }
    });
  }

  close() {
    this.router.navigate(["data-source"]);
  }

  /** Loads the log the first time its step is opened, not on every save. */
  onStepChange(event: any) {
    if (this.mapperId && event && event.selectedIndex === 3 && !this.requestLogLoaded) {
      this.loadRequestLog(0);
    }
  }

  loadRequestLog(page: number) {
    if (!this.mapperId || !this.service.name) {
      return;
    }
    this.requestLogLoading = true;
    this.requestLogFailed = false;
    this.requestLogPage = page;
    this.expandedLogRow = -1;

    this.dataSourceService
      .getRequestLog(this.service.name, page, this.requestLogPageSize)
      .subscribe(
        (result: any) => {
          const rows = result ? result.data || result.Data || [] : [];
          // The endpoint matches on name, so keep only this data source's own rows.
          this.requestLog = rows.filter(
            (row) => !row.apiMapperId || +row.apiMapperId === +this.mapperId,
          );
          this.requestLogTotal = result ? result.totalCount || result.TotalCount || 0 : 0;
          this.requestLogLoading = false;
          this.requestLogLoaded = true;
        },
        () => {
          this.requestLog = [];
          this.requestLogFailed = true;
          this.requestLogLoading = false;
          this.requestLogLoaded = true;
        },
      );
  }

  get requestLogHasNextPage(): boolean {
    return (this.requestLogPage + 1) * this.requestLogPageSize < this.requestLogTotal;
  }

  toggleLogRow(index: number) {
    this.expandedLogRow = this.expandedLogRow === index ? -1 : index;
  }

  /** Pretty-prints a logged request or response, or returns it unchanged. */
  prettyJson(value: string): string {
    if (!value) {
      return "—";
    }
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  }

  /**
   * Ticks the parameter-type boxes for the sections that already hold values.
   * Called once after loading; doing this from the template made the bindings
   * change during change detection (NG0100).
   */
  syncInputSections() {
    if (this.queryStringValues.length) {
      this.input.QueryString = true;
    }
    if (this.headerValues.length) {
      this.input.Header = true;
    }
    if (this.pathValues.length) {
      this.input.Path = true;
    }
    if (this.formFileValues.length) {
      this.input.FormFile = true;
    }
    if (this.bodyValues.length || this.arrayBodyValues.length) {
      this.input.Body = true;
      if (!this.input.BodyType) {
        this.input.BodyType = this.arrayBodyValues.length && !this.bodyValues.length ? "2" : "1";
      }
    }
  }

  outputSelectHandler(item) {
    let itemResult = this.dataSourceObject.outputs.find(
      (element) => item.paramName === element,
    );

    item.selected = !item.selected;
    if (!itemResult) {
      this.dataSourceObject.outputs.push(item.paramName);
    }
  }

  // assignParams(e: any) {
  //   for (let i = 0; i < this.unAssigendOutParams.length; i++) {
  //     const unAssSite = this.unAssigendOutParams[i];
  //     if (unAssSite == e.dragData) {
  //       this.unAssigendOutParams.splice(i, 1);
  //     }
  //   }
  //   this.assigendOutParams.push({
  //     name: e.dragData.name ? e.dragData.name : e.dragData,
  //     alias: e.dragData.alias ? e.dragData.alias : null,
  //   });
  // }

  // unAssignParams(e: any) {
  //   for (let i = 0; i < this.assigendOutParams.length; i++) {
  //     const unAssSite = this.assigendOutParams[i];
  //     if (unAssSite == e.dragData) {
  //       this.assigendOutParams.splice(i, 1);
  //     }
  //   }
  //   this.unAssigendOutParams.push(e.dragData);
  // }
  assignParams(event: CdkDragDrop<any[]>) {
    if (event.previousContainer !== event.container) {
      // Moving item from unassigned roles to assigned roles
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      event.container.data[event.currentIndex] = this.asOutputField(
        event.container.data[event.currentIndex],
      );
    }
  }

  /**
   * One selected output field. A field that comes back from the server carries
   * its id, which is what a parameter of another data source links to; a field
   * just dragged out of the Test result has none yet.
   */
  private asOutputField(field: any): any {
    if (field && typeof field === "object") {
      return {
        id: field.id || 0,
        name: field.name || field.paramName,
        alias: field.alias || "",
      };
    }
    return { id: 0, name: field, alias: "" };
  }

  /** The selected output fields in the shape AddDataSource/EditDataSource take. */
  private buildOutputsPayload(): any[] {
    return (this.assigendOutParams || []).map((field: any) => {
      const output = this.asOutputField(field);
      return {
        Id: output.id || 0,
        Name: output.name,
        Alias: output.alias || null,
      };
    });
  }

  unAssignParams(event: CdkDragDrop<any[]>) {
    if (event.previousContainer !== event.container) {
      // Moving item from assigned roles to unassigned roles
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }
  EditInputHandler(source, item, index) {
    this.tempInputParams = item[index];
    source.Name = item[index].paramName;
    source.ValueSource = item[index].sourceType;
    source.Value = item[index].parentField || item[index].paramValue;
    source.defaultValue = item[index].defaultValue;
    source.ParentApiId = item[index].parentApiId || 0;
    source.ParentOutputParamId = item[index].parentOutputParamId || null;
    if (+source.ParentApiId) {
      this.loadParentOutputs(+source.ParentApiId);
    }
    item.splice(index, 1);
  }

  //Note :Dont remove this function until take confirmation about design, creaeted by Mahmoud Awwad
  // getClass(inputObject) {
  //   if (!inputObject.ValueSource) {
  //     return 'col-md-4';
  //   } else if (inputObject.ValueSource && (inputObject.ValueSource != 2 && inputObject.ValueSource != 6)) {
  //     return 'col-md-3';
  //   } else if (inputObject.ValueSource && (inputObject.ValueSource == 2 || inputObject.ValueSource == 6)) {
  //     return 'col-md-4'
  //   }
  // }

  getButtonClass(inputObject) {
    if (!inputObject.ValueSource) {
      return "col-md-6";
    } else if (inputObject.ValueSource && inputObject.ValueSource == 11) {
      return "col-md-3";
    } else if (inputObject.ValueSource && inputObject.ValueSource == 9) {
      return "col-md-12";
    } else if (
      inputObject.ValueSource &&
      (inputObject.ValueSource == 2 || inputObject.ValueSource == 6)
    ) {
      return "col-md-6";
    } else if (
      inputObject.ValueSource &&
      inputObject.ValueSource != 2 &&
      inputObject.ValueSource != 6
    ) {
      return "col-md-3";
    }
  }

  openAlert(message: string) {
    this.snotifyService.error("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  ///////////////////////////////start alias///////////////////////////////////////////////
  indexOfOutput = 0;
  openDialogTemplateAlias(dialogtemplatealias: any, index: number): void {
    this.indexOfOutput = index;
    this.dialog.open(dialogtemplatealias, { width: "70vw" });
    console.log(this.service);

    if (this.service.outputs) {
      this.aliasform
        .get("alias")
        .setValue(this.service.outputs[this.indexOfOutput].alias);
    } else {
      this.aliasform
        .get("alias")
        .setValue(this.dataSourceObject.outputs[this.indexOfOutput]["alias"]);
    }
  }

  addAlias() {
    if (!this.mapperId) {
      const current = this.asOutputField(this.assigendOutParams[this.indexOfOutput]);
      current.alias = this.aliasform.get("alias").value || "";
      this.assigendOutParams[this.indexOfOutput] = current;

      this.dataSourceObject.outputs = this.buildOutputsPayload();
    } else {
      let apiMapperViewModel = {
        accept: this.service.accept,
        apiMapperParams: this.service.apiMapperParams,
        apiReponseType: this.service.apiReponseType,
        authorizationKeys: this.service.authorizationKeys,
        authorizationType: this.service.authorizationType,
        contentType: this.service.contentType,
        contractName: this.service.contractName,
        description: this.service.description,
        httpMethod: this.service.httpMethod,
        id: this.service.id,
        mediaTypes: this.service.mediaTypes,
        name: this.service.name,
        parentId: this.service.parentId,
        siteId: this.service.siteId,
        status: this.service.status,
        type: this.service.type,
        url: this.service.url,
        webMethodName: this.service.webMethodName,
      };
      var outputs = this.service.outputs;
      var inputs = this.service.inputs;
      var path = this.service.path;

      if (this.service.path == null) {
        path = [];
      }
      var tokenSource = this.service.tokenSource;
      var dataSourceObject1 = {
        outputs: outputs,
        inputs: inputs,
        paths: path,
        tokenSource: tokenSource,
        apiMapperViewModel: apiMapperViewModel,
      };

      dataSourceObject1.outputs[this.indexOfOutput]["alias"] =
        this.aliasform.get("alias").value;
      this.httpClient
        .post(`/ApiInvoker/EditDataSource`, dataSourceObject1)
        .subscribe((res) => {
          this.snotifyService.success(`Data source edited successfully`, "", {
            timeOut: 2000,
            progressBar: true,
            tapToDismiss: true,
          });
          // this.router.navigateByUrl("/data-source");
          // this.pathArray = [];
        });
    }
  }
  ///////////////////////////////end alias///////////////////////////////////////////////
}
